export enum EMailTemplateTypes {
    PASSWORD_RESET = "PASSWORD_RESET",
    VERIFY_EMAIL = "VERIFY_EMAIL",
	PURCHASE_RECEIPT = 'PURCHASE_RECEIPT',
	PURCHASE_RECEIPT_BODY = 'PURCHASE_RECEIPT_BODY',
    CONFIRMATION_SUPPORT = 'CONFIRMATION_SUPPORT'
}